import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const PunchLogList = Loadable(
  lazy(() => import("features/biometric/components/PunchLogList"))
);
const ConfigurationList = Loadable(
  lazy(() => import("features/biometric/components/ConfigurationList"))
);
const ConfigurationForm = Loadable(
  lazy(() => import("features/biometric/components/ConfigurationForm"))
);

const routes = {
  path: "biometric",
  children: [
    { path: "", element: <PunchLogList /> },
    { path: "punch-logs", element: <PunchLogList /> },
    { path: "configuration", element: <ConfigurationList /> },
    { path: "configuration/add", element: <ConfigurationForm /> },
    { path: "configuration/edit/:id", element: <ConfigurationForm /> },
  ],
};

export default routes;
